import React, { useCallback, useEffect, useState } from "react";
import {
	Box,
	ButtonLayout,
	Grid,
	GridItem,
	skinVars,
	Spinner,
	Text5,
	useScreenSize,
} from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import { strings } from "../../../localization";
import { Button } from "../../atoms";
import { ScreenResponsive } from "../../organisms";
import axios from "axios";
import { TypeContractEnum } from "../../../enum/contract";
import { useAnalytics } from "../../../hooks/useAnalytics";
import { useNavigateCustom } from "../../../hooks";

interface ViewDocumentProps {
	url: string;
	type: TypeContractEnum;
}

const { contractViewer, navigation } = strings.pages;
const { back } = strings.components.buttons;

export const ViewDocument: React.FC<ViewDocumentProps> = observer(({ url, type }) => {
	const [file, setFile] = useState("");
	const { isDesktopOrBigger } = useScreenSize();
	const navigate = useNavigateCustom();
	const [loading, setLoading] = useState(false);

	let label;
	switch (type) {
		case TypeContractEnum.ACCOUNT_CREATION:
			label = contractViewer.accountCreation;
			break;
		case TypeContractEnum.ANTICIPATION_CONTRACT:
			label = contractViewer.labelContract;
			break;
		case TypeContractEnum.VIVO_PAY_AWARD:
			label = contractViewer.vivoPayAward;
			break;
	}

	const { addAnalyticEvent, updatePageView } = useAnalytics();

	useEffect(() => {
		getPDF();
	}, []);

	useEffect(() => {
		updatePageView({
			name: "Vivo Money FGTS Contrato de Antecipação",
			pagePath: "/fgts/contrato-de-antecipacao",
		});
	}, []);

	const getPDF = useCallback(async (): Promise<void> => {
		try {
			setLoading(true);
			const response = await axios.get(url, { responseType: "blob" });
			const pdfPathTemp = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
			setFile(pdfPathTemp);
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	}, [url]);

	return (
		<ScreenResponsive navigationTitle={navigation.anticipation} onBack={() => navigate(-1)}>
			<Box paddingTop={40}>
				<Grid
					columns={{ maxSize: 600 }}
					gap={isDesktopOrBigger ? 40 : 24}
					min-height={"100vh"}
					rows={2}
					alignItems={"center"}
					justifyContent={"center"}
				>
					<GridItem columnStart={1} span={4} rowSpan={1}>
						<Text5 color={skinVars.colors.textPrimary}>{label}</Text5>
					</GridItem>

					<GridItem columnStart={1} span={4}>
						{loading && (
							<Box className="load-pdf">
								<Spinner size={24} />
							</Box>
						)}

						{!loading && file && (
							<div style={{ width: "100%", height: "64vh", border: "0.5px solid #EFF0F7" }}>
								<object
									data={file}
									type="application/pdf"
									width="100%"
									height="100%"
								>
									<p>
                    Não foi possível exibir o PDF.
										<a href={file} target="_blank" rel="noopener noreferrer">Clique aqui para baixar</a>.
									</p>
								</object>
							</div>
						)}

						<Box paddingY={40}>
							<ButtonLayout>
								<Button
									testID="button-go-back-pdf"
									styles={{ width: "100%" }}
									textButton={back}
									onAction={async () => {
										navigate(-1);
										addAnalyticEvent(
											{
												description: back,
												step: "fgts:contrato-de-antecipacao",
												action: "click.button",
											},
											{ applySanitize: true },
										);
									}}
								/>
							</ButtonLayout>
						</Box>
					</GridItem>
				</Grid>
			</Box>
		</ScreenResponsive>
	);
});
